/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
theme.nwCollection = function () {
  const toggleButtons = document.querySelectorAll(".view-toggle button");
  const collectionTable = document.querySelector(".collection__table-view");
  const collectionCards = document.querySelector(".collection__cards");

  //make sure view remains after pagination click
  function ensureViewOnPaginationChangeByLocalStorage() {
    if (localStorage.getItem("collection-display-type") == "list") {
      if (toggleButtons.length !== 0) {
        document
          .querySelector('button[data-view="grid"]')
          .classList.remove("active");
        document
          .querySelector('button[data-view="list"]')
          .classList.add("active");
        collectionCards.style.display = "none";
        collectionTable.style.display = "table";
      }
    } else {
      if (toggleButtons.length !== 0) {
        document
          .querySelector('button[data-view="list"]')
          .classList.remove("active");
        document
          .querySelector('button[data-view="grid"]')
          .classList.add("active");
        collectionCards.style.display = "block";
        collectionTable.style.display = "none";
      }
    }
  }

  // init toggle Buttons
  function initToggleButtonsForTableGridSwitch() {
    toggleButtons.forEach((button) => {
      button.addEventListener("click", function () {
        toggleButtons.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");

        if (this.dataset.view === "list") {
          collectionCards.style.display = "none";
          collectionTable.style.display = "table";
          localStorage.setItem("collection-display-type", "list");
        } else {
          collectionCards.style.display = "block";
          collectionTable.style.display = "none";
          localStorage.setItem("collection-display-type", "grid");
        }
        //makes the grid-products appear
        window.dispatchEvent(new Event("resize"));
      });
    });
  }

  initToggleButtonsForTableGridSwitch();
  if (document.querySelector(".collection__table-view") !== null) {
    ensureViewOnPaginationChangeByLocalStorage();
  }
};

theme.nwCollection();

function runWhenJQuery(init) {
  function tryRun() {
    if (window.jQuery) {
      window.jQuery(init);
      return true;
    }
    return false;
  }
  if (tryRun()) return;
  var attempts = 0;
  var id = setInterval(function () {
    if (tryRun() || ++attempts > 120) clearInterval(id);
  }, 50);
}

function checkAnnouncementHidden() {
  if (!window.jQuery) return;
  if (window.jQuery('.announcement').is('[hidden]')) {
    window.jQuery('body').addClass('announcement-hidden');
  } else {
    window.jQuery('body').removeClass('announcement-hidden');
  }
}
const header = document.querySelector("header");
const announcement = document.querySelector(".announcement__container"); // ✅ Updated selector
const body = document.body;
const actionsElement = document.querySelector(".collection-main__actions");
const actionsElement2 = document.querySelector(".view-toggle");
const actionsElement3 = document.querySelector(".filter-part");

function updateTopPosition() {
  if (!header) return;

  const headerHeight = header.offsetHeight || 0;
  const announcementHeight = announcement ? announcement.offsetHeight : 0;

  const totalHeight = headerHeight + announcementHeight;
  const isMobile = window.innerWidth <= 979;

  requestAnimationFrame(() => {
    if (body.classList.contains("header-down")) {
      if (actionsElement2) actionsElement2.style.top = `${totalHeight - 1}px`;
      if (actionsElement3) actionsElement3.style.top = `${totalHeight}px`;

      if (isMobile) {
        if (actionsElement) actionsElement.style.top = `${totalHeight - 1}px`;
        if (actionsElement2) actionsElement2.style.top = `${totalHeight + 50}px`;
      } else {
        if (actionsElement) actionsElement.style.top = "";
      }
    } else {
      if (actionsElement) actionsElement.style.top = "";
      if (actionsElement2) actionsElement2.style.top = "";
      if (actionsElement3) actionsElement3.style.top = "";
    }
  });
}

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      updateTopPosition();
    }
  }
});

if (header) {
  observer.observe(body, { attributes: true });
  window.addEventListener("resize", updateTopPosition);
  window.addEventListener("load", updateTopPosition);
}

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    '.add-both_product[data-page="neue-kunde-angebot-brokkoli-sprossensamen"]'
  );

  if (buttons.length > 0) {
    buttons.forEach((btn) => {
      btn.addEventListener("click", async function (e) {
        e.preventDefault();

        // 2 products with quantity = 1 each
        const productsToAdd = {
          items: [
            { id: 44938558669093, quantity: 1 },
            { id: 54401198752129, quantity: 1 },
          ],
        };

        try {
          // Add products (keeps existing cart items)
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(productsToAdd),
          });

          // Redirect to checkout with discount code
          window.location.href = "/checkout?discount=BROKKOLI";
        } catch (error) {
          console.error("Error adding products:", error);
          window.location.href = "/checkout?discount=BROKKOLI";
        }
      });
    });
  }
});

// for button
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".add-both_product").forEach(btn => {
    btn.addEventListener("click", () => {
      btn.classList.remove("clicked");   // reset animation
      void btn.offsetWidth;              // force reflow
      btn.classList.add("clicked");

      // remove after animation so it can replay
      setTimeout(() => btn.classList.remove("clicked"), 700); // match 0.8s
    });
  });
});

runWhenJQuery(function () { 
    const validCodes = ["HIGHVIBE10"];

    $(document).on("input", ".kaching-cart__discount-code-input", function () {

        let typed = $(this).val();  // NO uppercase/lowercase conversion

        // strict EXACT match (case-sensitive) 
        if (validCodes.includes(typed)) {
            $("#discount-popup").css("display", "flex");
        }
    });

    $(document).on("click", "#close-discount-popup", function () {
        $("#discount-popup").css("display", "none");
    });

$('.payment-icons svg').each(function() {
  if ($(this).css('display') === 'none') {
    $(this).closest('li').css('display', 'none');
  }
});

    if ($('#custom-scroll-form-app').length) {
      $('.home-carousel__btn, .home-custom__btn').on('click', function(e){
        e.preventDefault();
        var target = $(this).attr('href');

        var headerHeight = ($('.header').outerHeight() || 0) + ($('.announcement__bg').outerHeight() || 0);

        $('html, body').animate({
          scrollTop: $(target).offset().top - headerHeight
        }, 800);
      });
    }

  $('.templatenew-neue-kunde-angebot-brokkoli-sprossensamen .image-banner__link,.templatenew-neue-kunde-angebot-brokkoli-sprossensamen .home-custom__btn').on('click', function(e){
  e.preventDefault();
  var target = $(this).attr('href');


  $('html, body').animate({
  scrollTop: $(target).offset().top
  }, 800);
  });

  // Watch for changes to the 'hidden' attribute
  const target = document.querySelector('.announcement');
  if (target) {
    const observer = new MutationObserver(checkAnnouncementHidden);
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['hidden']
    });
  }
  
  $(".product-accordion .accordion-item").on("click", function () {
    $(".product-accordion .accordion-item .collapse-block").slideUp();
    $(".product-accordion .accordion-item").removeClass("active");

    const answerBlock = $(this).find(".collapse-block");

    if (!answerBlock.is(":visible")) {
      answerBlock.slideDown();
      $(this).addClass("active");
    }
  });

  if ($(".product-accordion .accordion-item").length > 0) {
    $(".product-accordion .accordion-item").first().trigger("click");
  }
});
function setAnnouncementHeight() {

  const announcement = document.querySelector('[data-section-type="announcement-bar"]');
  const header = document.querySelector('header-container');

  if (announcement && header) {
    const height = announcement.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--announcement-height', height + 'px');
  } else {
    console.log('not found');
    document.documentElement.style.setProperty('--announcement-height', '0px');
  }
}

setAnnouncementHeight();

window.addEventListener('resize', setAnnouncementHeight);

document.addEventListener('shopify:section:load', setAnnouncementHeight);